export const methods = {
    words: {
        list: "dictionary.words.list",
        details: {
            get: "dictionary.words.details.get"},
        enrich: "dictionary.words.enrich",
        unnecessaryEntities: {
            delete: "dictionary.words.unnecessaryEntities.delete"},
        problemWords: {
            list: "dictionary.words.problemWords.list"},
        reviewElements: {
            list: "dictionary.words.reviewElements.list"},
        review: "dictionary.words.review",
        search: "dictionary.words.search",
        metadata: {
            get: "dictionary.words.metadata.get"},
        images: {
            create: "dictionary.words.images.create"},
        admin: {
            create: "dictionary.words.admin.create",
            list: "dictionary.words.admin.list",
            setStatus: "dictionary.words.admin.setStatus",
            byId: {
                get: "dictionary.words.admin.byId.get"},
            languages: {
                count: "dictionary.words.admin.languages.count"},
            tags: {
                list: "dictionary.words.admin.tags.list",
                setStatus: "dictionary.words.admin.tags.setStatus"},
            partsOfSpeech: {
                list: "dictionary.words.admin.partsOfSpeech.list",
                setStatus: "dictionary.words.admin.partsOfSpeech.setStatus"},
            relatedWords: {
                list: "dictionary.words.admin.relatedWords.list",
                setStatus: "dictionary.words.admin.relatedWords.setStatus"},
            definitions: {
                list: "dictionary.words.admin.definitions.list",
                setStatus: "dictionary.words.admin.definitions.setStatus"},
            media: {
                list: "dictionary.words.admin.media.list",
                setStatus: "dictionary.words.admin.media.setStatus"},
            attributes: {
                list: "dictionary.words.admin.attributes.list",
                setStatus: "dictionary.words.admin.attributes.setStatus"},
            translations: {
                list: "dictionary.words.admin.translations.list",
                setStatus: "dictionary.words.admin.translations.setStatus"},
            examples: {
                list: "dictionary.words.admin.examples.list",
                setStatus: "dictionary.words.admin.examples.setStatus"},
            exampleLinks: {
                list: "dictionary.words.admin.exampleLinks.list",
                setStatus: "dictionary.words.admin.exampleLinks.setStatus"},
            exampleTranslations: {
                list: "dictionary.words.admin.exampleTranslations.list",
                setStatus: "dictionary.words.admin.exampleTranslations.setStatus"}}},
    tags: {
        list: "dictionary.tags.list",
        bySlug: "dictionary.tags.bySlug",
        images: "dictionary.tags.images",
        tree: "dictionary.tags.tree",
        hierarchy: "dictionary.tags.hierarchy",
        admin: {
            all: "dictionary.tags.admin.all",
            setStatus: "dictionary.tags.admin.setStatus"}},
    partsOfSpeech: {
        admin: {
            list: "dictionary.partsOfSpeech.admin.list",
            setStatus: "dictionary.partsOfSpeech.admin.setStatus"}},
    languages: {
        admin: {
            list: "dictionary.languages.admin.list",
            setStatus: "dictionary.languages.admin.setStatus"}},
    dq: {
        openIssues: {
            list: "dictionary.dq.openIssues.list",
            count: "dictionary.dq.openIssues.count"}},
    sitemap: {
        languages: "dictionary.sitemap.languages",
        words: "dictionary.sitemap.words"}};


  export const typedMethods = {};
